export enum SessionParticipant {
    Student = 0,
    Coach = 1,
}
